import React from 'react';
export function TomiSection() {
  return <section className="py-8 px-4 bg-white" data-id="element-181">
      <div className="max-w-2xl mx-auto text-center" data-id="element-182">
        <h2 className="text-xl sm:text-2xl font-heading font-bold text-brand-forest mb-4 leading-tight" data-id="element-183">
          Te presentamos el Protocolo Maestro: TIROIDES EN RESCATE™
        </h2>
        <p className="text-sm sm:text-base text-brand-text leading-relaxed" data-id="element-184">
          Este no es un recetario común de "comida sana". Es un{' '}
          <strong className="text-brand-forest" data-id="element-185">
            sistema de rescate rápido
          </strong>{' '}
          diseñado para la mujer latina que no tiene tiempo de cocinar y
          necesita resultados visibles. Aquí aprenderás a usar ingredientes
          económicos y potentes para equilibrar tu energía en tiempo récord.
        </p>
      </div>
    </section>;
}